export class AgentDesktopApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Claim a conversation for the SIGNED-IN agent (D397: the claimer is never named in the body). A conversation someone
     * owns is refused (collision guard → 409); a RELEASED one is taken again (D419). D419: the conversation must exist in
     * the named realm (400 `REALM_MISMATCH`) and in the caller's market (403 otherwise).
     */
    claim(input) {
        return this.client.request({ method: 'POST', path: '/v1/agent-desktop/assignments', body: input, auth: true });
    }
    /**
     * Reassign a conversation to another agent (only an owned conversation can be reassigned → 409 otherwise). `agentId`
     * is the TARGET; who reassigns is the signed-in operator, recorded on `lastAction` (D414).
     */
    reassign(conversationId, agentId) {
        return this.client.request({ method: 'POST', path: `/v1/agent-desktop/assignments/${encodeURIComponent(conversationId)}/reassign`, body: { agentId }, auth: true });
    }
    /** Release a conversation — its owner gives it up; the releasing operator is the session, recorded on `lastAction` (D414). */
    release(conversationId) {
        return this.client.request({ method: 'POST', path: `/v1/agent-desktop/assignments/${encodeURIComponent(conversationId)}/release`, body: {}, auth: true });
    }
    /** Read a conversation assignment + its current revision. */
    get(conversationId) {
        return this.client.request({ method: 'GET', path: `/v1/agent-desktop/assignments/${encodeURIComponent(conversationId)}`, auth: true });
    }
    /** D419: who owns what right now — the ASSIGNED conversations of a realm in the caller's markets, newest first. */
    listActiveByRealm(realm) {
        return this.client.request({ method: 'GET', path: `/v1/agent-desktop/assignments?realm=${encodeURIComponent(realm)}`, auth: true });
    }
    /** List the conversations handled by an agent (newest first) — in the caller's markets (D419). */
    listByAgent(agentId) {
        return this.client.request({ method: 'GET', path: `/v1/agent-desktop/assignments?agentId=${encodeURIComponent(agentId)}`, auth: true });
    }
    /**
     * The ACTIVE operators who work the desk (`agent_desk:assign`/`agent_desk:view`) in a market the caller supervises, by
     * name — for the owner column and the hand-over picker. Needs `agent_desk:supervise` (403 otherwise), not the operator
     * directory's admin word.
     */
    listAgents() {
        return this.client.request({ method: 'GET', path: '/v1/agent-desktop/agents', auth: true });
    }
}
//# sourceMappingURL=agent-desktop.js.map